let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jGfYW")).then(() => parcelRequire('6BtpO'));